import React from 'react';
import ProgressBar from '../../../uikit/misc/ProgressBar';
import useEmotionStyles from '../../../uikit/hooks/useEmotionStyles';
var styles = function (theme) {
    var _a;
    return ({
        root: (_a = {},
            _a[theme.breakpoints.down('sm')] = {
                position: 'sticky',
                top: '0',
                left: '0',
                margin: '-16px -16px 0',
                background: 'white',
                zIndex: 1,
            },
            _a),
    });
};
export var StickyProgressBar = function (_a) {
    var value = _a.value;
    var cs = useEmotionStyles(styles);
    return (React.createElement("div", { className: cs.root },
        React.createElement(ProgressBar, { value: value })));
};
